module.exports = {"TXTWCL_Just_so_you_know":{"id":"TXTWCL_Just_so_you_know","defaultMessage":"Zu deiner Information","track":"Just so you know"}}